import type React from "react";
import type { ReactNode } from "react";
import { Footer } from "~/components/Footer";
import { Header } from "~/components/Header";

interface Props {
	children: ReactNode;
}

export const DocumentLayout: React.FC<Props> = ({ children }) => {
	return (
		<section className="document-page">
			<Header withLanguageSwitch />
			{children}
			<Footer />
		</section>
	);
};
